import type { SubEnvironment } from '@change-corgi/config/environments';
import { getFacebookNamespace } from '@change-corgi/config/facebook';

import type { PrefetchContext } from 'src/shared/prefetch';

import type { PetitionDetailsMetaContext } from './types';

export function buildMetaContext(context: PrefetchContext): PetitionDetailsMetaContext {
	const env =
		context.utilityContext.environment.getDemoEnvironment() || context.utilityContext.environment.getEnvironment();

	return {
		facebookNamespace: getFacebookNamespace(env as unknown as SubEnvironment) || undefined,
		ogUrlPath: context.path,
	};
}
